<template>

    <div v-if="annotationLayer === 'human_payroll'">
        <v-list dense nav>
            <template
                v-for="label in labels[annotationLayer]"
            >
                <v-list-item
                v-bind:key="label.name"
                class="pa-0"
                >
                    <v-list-item-content
                        class="pb-0 pt-1"
                        :class="{selectedrow:label.name===selectedLabel}"
                        style="height:50px"
                    >
                        <v-row no-gutters>
                        <v-col 
                            cols="1"
                            class="pt-2 pb-0 pr-0"
                        >
                            <v-icon
                            v-if="label.name===selectedLabel" color="primary"
                            class="selected-chevron"
                            >mdi-chevron-right</v-icon>
                        </v-col>
                        <v-col
                            v-if="currentDocument"
                            cols="7"
                            class="pt-0 pb-0 pl-0 pr-0"
                        >
                            <v-text-field
                            outlined
                            :label="label.text"
                            @focus="selectLabel({ label: label.name })"
                            v-model="currentDocumentData[label.name]"
                            dense
                            readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2" class="pt-0 pb-0 pr-0 pl-2">
                            <v-btn
                            v-bind:color="label.color"
                            @click="selectLabel({ label: label.name })"
                            width="10"
                            min-width="10"
                            >
                            <v-icon>mdi-tag</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="2" class="pt-0 pb-0 pl-0">
                            <v-btn
                            color="gray"
                            @click="deleteLabel({ label: label.name })"
                            width="10"
                            min-width="10"
                            >
                            <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-col>
                        </v-row>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-list>
    </div>


    <div v-else>

        <div>
            <v-row no-gutters class="pt-4 pl-4 pr-4">
                <v-col cols="12" >
                    <v-text-field
                            v-bind:color="formTag.inv_number.color"
                            :label="formTag.inv_number.text"
                            @focus="selectLabel({ label: formTag.inv_number.name })"
                            v-model="currentDocumentData[formTag.inv_number.name]"                            
                            clearable
                            @click:clear="deleteLabel({ label: formTag.inv_number.name})"
                            dense
                            readonly
                            >
                        <v-icon slot="append" v-bind:color="formTag.inv_number.color">
                            mdi-tag
                        </v-icon>
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row no-gutters class="pl-4 pr-4">
                <v-col cols="6" >
                    <v-text-field
                        v-bind:color="formTag.supplier.color"
                        :label="formTag.supplier.text"
                        @focus="selectLabel({ label: formTag.supplier.name })"
                        v-model="currentDocumentData[formTag.supplier.name]"
                        clearable
                        @click:clear="deleteLabel({ label: formTag.supplier.name})"
                        class="pr-2"
                        dense
                        readonly
                        >
                        <v-icon slot="append" v-bind:color="formTag.supplier.color">
                            mdi-tag
                        </v-icon>
                    </v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        v-bind:color="formTag.vat_supplier.color"
                        :label="formTag.vat_supplier.text"
                        @focus="selectLabel({ label: formTag.vat_supplier.name })"
                        v-model="currentDocumentData[formTag.vat_supplier.name]"
                        clearable
                        @click:clear="deleteLabel({ label: formTag.vat_supplier.name})"
                        class="pl-2"
                        dense
                        readonly
                        >
                        <v-icon slot="append" v-bind:color="formTag.vat_supplier.color">
                            mdi-tag
                        </v-icon>
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row no-gutters class="pl-4 pr-4">
                <v-col cols="6" >
                    <v-text-field
                        v-bind:color="formTag.customer.color"
                        :label="formTag.customer.text"
                        @focus="selectLabel({ label: formTag.customer.name })"
                        v-model="currentDocumentData[formTag.customer.name]"
                        clearable
                        @click:clear="deleteLabel({ label: formTag.customer.name})"
                        class="pr-2"
                        dense
                        readonly
                        >
                        <v-icon slot="append" v-bind:color="formTag.customer.color">
                            mdi-tag
                        </v-icon>
                    </v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        v-bind:color="formTag.vat_customer.color"
                        :label="formTag.vat_customer.text"
                        @focus="selectLabel({ label: formTag.vat_customer.name })"
                        v-model="currentDocumentData[formTag.vat_customer.name]"
                        clearable
                        @click:clear="deleteLabel({ label: formTag.vat_customer.name})"
                        class="pl-2"
                        dense
                        readonly
                        >
                        <v-icon slot="append" v-bind:color="formTag.vat_customer.color">
                            mdi-tag
                        </v-icon>
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row no-gutters class="pl-4 pr-4">
                <v-col cols="6" >
                    <v-text-field
                        v-bind:color="formTag.invoice_date.color"
                        :label="formTag.invoice_date.text"
                        @focus="selectLabel({ label: formTag.invoice_date.name })"
                        v-model="currentDocumentData[formTag.invoice_date.name]"
                        clearable
                        @click:clear="deleteLabel({ label: formTag.invoice_date.name})"
                        class="pr-2"
                        dense
                        readonly
                        >
                        <v-icon slot="append" v-bind:color="formTag.invoice_date.color">
                            mdi-tag
                        </v-icon>
                    </v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        v-bind:color="formTag.due_date.color"
                        :label="formTag.due_date.text"
                        @focus="selectLabel({ label: formTag.due_date.name })"
                        v-model="currentDocumentData[formTag.due_date.name]"
                        clearable
                        @click:clear="deleteLabel({ label: formTag.due_date.name})"
                        class="pl-2"
                        dense
                        readonly
                        >
                        <v-icon slot="append" v-bind:color="formTag.due_date.color">
                            mdi-tag
                        </v-icon>
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row no-gutters class="pl-4 pr-4">
                <v-col cols="6" >
                    <v-text-field
                        v-bind:color="formTag.retention_type.color"
                        :label="formTag.retention_type.text"
                        @focus="selectLabel({ label: formTag.retention_type.name })"
                        v-model="currentDocumentData[formTag.retention_type.name]"
                        clearable
                        @click:clear="deleteLabel({ label: formTag.retention_type.name})"
                        class="pr-2"
                        dense
                        readonly
                        >
                        <v-icon slot="append" v-bind:color="formTag.retention_type.color">
                            mdi-tag
                        </v-icon>
                    </v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        v-bind:color="formTag.retention_amount.color"
                        :label="formTag.retention_amount.text"
                        @focus="selectLabel({ label: formTag.retention_amount.name })"
                        v-model="currentDocumentData[formTag.retention_amount.name]"
                        clearable
                        @click:clear="deleteLabel({ label: formTag.retention_amount.name})"
                        class="pl-2"
                        dense
                        readonly
                        >
                        <v-icon slot="append" v-bind:color="formTag.retention_amount.color">

                            mdi-tag
                        </v-icon>
                    </v-text-field>
                </v-col>
            </v-row>
        </div>

        <v-divider></v-divider>
        
        <v-tabs v-model="selected.tab">
            <v-tab v-for="tab in tabsTags" :key="tab.code">
                {{ tab.text }}
            </v-tab>
        </v-tabs>

        <v-tabs-items v-model="selected.tab" class="ma-3">
            <v-tab-item :key="tab.code" v-for="tab in tabsTags">
                
                <v-list v-if="tab.code == 'params'" dense nav>
                    <template v-for="label in tab.tag_list">
                        <v-list-item
                        v-bind:key="label.name"
                        class="pa-0"
                        >
                            <v-list-item-content
                                class="pb-0 pt-1"
                                :class="{selectedrow:label.name===selectedLabel}"
                                style="height:50px"
                            >
                                <v-row no-gutters>
                                <v-col 
                                    cols="1"
                                    class="pt-2 pb-0 pr-0"
                                >
                                    <v-icon
                                    v-if="label.name===selectedLabel" color="primary"
                                    class="selected-chevron"
                                    >mdi-chevron-right</v-icon>
                                </v-col>
                                <v-col
                                    v-if="currentDocument"
                                    cols="7"
                                    class="pt-0 pb-0 pl-0 pr-0"
                                >
                                    <v-text-field
                                    outlined
                                    :label="label.text"
                                    @focus="selectLabel({ label: label.name })"
                                    v-model="currentDocumentData[label.name]"
                                    dense
                                    readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0 pr-0 pl-2">
                                    <v-btn
                                    v-bind:color="label.color"
                                    @click="selectLabel({ label: label.name })"
                                    width="10"
                                    min-width="10"
                                    >
                                    <v-icon>mdi-tag</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0 pl-0">
                                    <v-btn
                                    color="gray"
                                    @click="deleteLabel({ label: label.name })"
                                    width="10"
                                    min-width="10"
                                    >
                                    <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </v-col>
                                </v-row>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-list>
                
                <v-row v-else no-gutters>
                    <template>
                        <v-col cols="4" class="text-center table-head primary--text">Tipo</v-col>
                        <v-col cols="4" class="text-center table-head primary--text">Base</v-col>
                        <v-col cols="4" class="text-center table-head primary--text">Cuota</v-col>
                    </template>
                    <template v-for="vat in tab.vats" >
                        <v-col :key="'type_' + vat.vat" cols="4" class="text-center align-self-end table-row">
                            <v-text-field
                                    v-model="vat.label"
                                    readonly
                                    class="left-input"
                                    single-line
                                    dense
                                    hide-details
                                    >
                            </v-text-field>
                        </v-col>
                        <v-col :key="'base_' + vat.vat"  cols="4" class="text-center align-self-end table-row">
                              <v-text-field v-if="vat.tag_list"
                                    :label="vat.tag_list['base_' + vat.vat].text"
                                    @focus="selectLabel({ label: 'base_' + vat.vat })"
                                    :color="vat.tag_list['base_' + vat.vat].color"
                                    v-model="currentDocumentData['base_' + vat.vat]"
                                    readonly
                                    clearable
                                    class="right-input"
                                    @click:clear="deleteLabel({ label: 'base_' + vat.vat})"
                                    single-line
                                    dense
                                    hide-details
                                    >
                                    <v-icon slot="append" v-bind:color="vat.tag_list['base_' + vat.vat].color">
                                        mdi-tag
                                    </v-icon>
                                </v-text-field>
                        </v-col>
                        <v-col :key="'cuota_' + vat.vat" cols="4" class="text-center align-self-end table-row">
                            <v-text-field v-if="vat.tag_list"
                                    :label="vat.tag_list[vat.vat].text"
                                    @focus="selectLabel({ label: vat.vat })"
                                    :color="vat.tag_list[vat.vat].color"
                                    v-model="currentDocumentData[vat.vat]"
                                    clearable
                                    class="right-input"
                                    @click:clear="deleteLabel({ label: vat.vat})"
                                    readonly
                                    single-line
                                    dense
                                    hide-details
                                    >
                                    <v-icon slot="append" v-bind:color="vat.tag_list[vat.vat].color">
                                        mdi-tag
                                    </v-icon>
                            </v-text-field>
                        </v-col>
                    </template>
                </v-row>


            </v-tab-item>
        </v-tabs-items>

        <div>
            <v-row no-gutters class="pt-4 pl-4 pr-4">
                <v-col cols="6">
                    <v-text-field
                        v-bind:color="formTag.other_amounts.color"
                        :label="formTag.other_amounts.text"
                        @focus="selectLabel({ label: formTag.other_amounts.name })"
                        v-model="currentDocumentData[formTag.other_amounts.name]"
                        clearable
                        @click:clear="deleteLabel({ label: formTag.other_amounts.name})"
                        class="pr-2"
                        dense
                        readonly
                        >
                        <v-icon slot="append" v-bind:color="formTag.other_amounts.color">

                            mdi-tag
                        </v-icon>
                    </v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        v-bind:color="formTag.total_amount.color"
                        :label="formTag.total_amount.text"
                        @focus="selectLabel({ label: formTag.total_amount.name })"
                        v-model="currentDocumentData[formTag.total_amount.name]"
                        clearable
                        @click:clear="deleteLabel({ label: formTag.total_amount.name})"
                        class="pl-2"
                        dense
                        readonly
                        >
                        <v-icon slot="append" v-bind:color="formTag.total_amount.color">

                            mdi-tag
                        </v-icon>
                    </v-text-field>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapFields } from "vuex";
import { BASES_LABELS, TAXES_LABELS } from "../store/constants";



export default {
    name: 'TrainerTagInfo',
    data () {
        return {
            selected: {
                tab: null
            }
        }
    },
    methods: {
        show_vat(vat){
            let show = true; 
            if(['vat_10_5','vat_12'].includes(vat) && !this.currentCompany.iva_agrario_pesca){
                show = false;
            } else if(['vat_re_1_75'].includes(vat) && !this.currentCompany.iva_tabaco){
                show = false;
            }
            return show;
        },
        ...mapActions({
            deleteLabel: "documents/deleteLabel",
            selectLabel: "documents/selectLabel",
        }),
    },
    computed: {
        ...mapGetters(['labels']),
        ...mapGetters({
            currentDocumentData: "documents/currentDocumentData",
            annotationLayer: "documents/annotationLayer",
            currentDocument: "documents/currentDocument",
            selectedLabel: "documents/selectedLabel",
            has_meta_iva: "documents/has_meta_iva",
            has_meta_igic: "documents/has_meta_igic",
            tabsTags: "tax_tab/getInitialTagTab",
            currentCompany:"getCurrentCompany",
            formTag: 'tax_tab/formTag'
        })
    }
}

</script>

<style scoped>
.table-head{
    border-left-style:solid;
    border-right-style:solid;
    border-bottom-style:solid;
    border-color:#663399;
    border-width: thin;
}
.table-row{
    border-left-style:solid;
    border-right-style:solid;
    border-color:#663399;
    border-width: thin;
}
.right-input >>> input {
      text-align: right;
      margin-right: 10px;
}
.left-input >>> input {
      text-align: left;
      margin-left: 10px;
}
</style>